import { useAuthModal } from '@/contexts/AuthModalContext'
import { useAuth } from '@/hooks/useAuth'
import {ArrowRight, Check, Sparkles, Star} from 'lucide-react'
import { Link } from 'react-router-dom'

const INCLUDED = [
  'Branded social profile & storefront',
  'Unlimited photos of singles and sealed product',
  'TCGplayer & eBay links on every listing',
  'Live Pokemon feed placement',
  'Toggle cards or sealed product on every post',
  'No payment needed during the open beta',
]

function Pricing() {
  const { isAuthenticated } = useAuth()
  const { openAuth } = useAuthModal()

  return (
    <div className="mx-auto max-w-4xl overflow-x-hidden px-4 py-10 sm:px-6 sm:py-16">
      <div className="mb-8 text-center">
        <div className="mb-4 inline-flex items-center gap-1.5 rounded-full bg-[#FFDE00] px-3 py-1 text-xs font-extrabold uppercase tracking-wide text-black shadow-[0_3px_0_#c9a800]">
          <Sparkles className="h-3.5 w-3.5" />
          Free Open Beta
        </div>
        <h1 className="font-display text-3xl font-extrabold text-white sm:text-6xl">One playful plan. Zero clutter.</h1>
        <p className="mx-auto mt-3 max-w-lg text-sm font-semibold text-white/65">
          Join the free open beta. Set up your store, post singles and sealed product, and share your shop link. No Stripe or card required yet.
        </p>
      </div>

      <div className="relative overflow-hidden rounded-[32px] border-4 border-[#3B4CCA] bg-[#111111] p-6 shadow-[12px_12px_0_rgba(255,26,26,0.28)] sm:p-10">
        <Star className="animate-sparkle absolute right-6 top-6 h-7 w-7 fill-[#FFDE00] text-[#FFDE00]" />
        <div className="flex flex-col gap-8 sm:flex-row sm:items-start">
          <div className="sm:w-2/5">
            <p className="text-xs font-extrabold uppercase tracking-[0.2em] text-[#8EA2FF]">Open beta</p>
            <div className="mt-2 flex items-end gap-1">
              <span className="font-display text-6xl font-extrabold text-[#FFDE00]">Free</span>
              <span className="mb-2 text-sm font-extrabold text-white/50">open beta</span>
            </div>
            <p className="text-sm font-semibold text-white/55">No payment setup yet. We will add billing after the beta.</p>
            {isAuthenticated ? (
              <Link
                to="/dashboard"
                className="mt-6 inline-flex w-full items-center justify-center gap-1.5 rounded-full bg-[#FFDE00] px-5 py-3 text-sm font-extrabold text-black shadow-[0_5px_0_#c9a800] transition-transform hover:-translate-y-1"
              >
                Open your dashboard
                <ArrowRight className="h-4 w-4" />
              </Link>
            ) : (
              <button
                type="button"
                onClick={openAuth}
                className="mt-6 inline-flex w-full items-center justify-center gap-1.5 rounded-full bg-[#FFDE00] px-5 py-3 text-sm font-extrabold text-black shadow-[0_5px_0_#c9a800] transition-transform hover:-translate-y-1"
              >
                Create your store
                <ArrowRight className="h-4 w-4" />
              </button>
            )}
          </div>
          <ul className="grid flex-1 gap-2.5">
            {INCLUDED.map(item => (
              <li key={item} className="flex items-start gap-2.5 rounded-2xl bg-white/5 px-3 py-2 text-sm font-bold text-white/85">
                <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-[#FF1A1A] text-white">
                  <Check className="h-3 w-3" />
                </span>
                {item}
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  )
}

export default Pricing
